// 20250719: xt/chtg converted the react-bootstrap to only bootstrap 5.3.3 
//         this way we can remove/uninstall react-bootstrap completely
import React from 'react'
import { connect } from 'react-redux'
import { hideModal, showModal, updateModalProps } from '../../actions/modal'
//import { Modal, ListGroup, ListGroupItem, FormGroup, FormControl, InputGroup } from 'react-bootstrap'

const SelectRoleModal = ({
  agency,
  incident,
  unitId,
  shiftId,
  reportSchemaId,
  roles,
  dispatch,
  visible,
  languageCode
}) => {
  const rolesMaster = agency.assignees.roles
  const hide = () => dispatch(hideModal())

  const saveSelection = (assignmentId) => {
    dispatch(hideModal())

    const startDateModalProps = {
      agency,
      incident,
      unitId,
      shiftId: assignmentId,
      reportSchemaId: incident.report_schema_id,
      assignedRole: incident.role_id,
      roleId: assignmentId,
      languageCode
    }

    dispatch(showModal('SELECT_START_DATE', startDateModalProps))
  }

  const filterList = (event) => {
    var updatedList = rolesMaster
    updatedList = updatedList.filter((item) => {
      return item.name[languageCode].toLowerCase().search(
        event.target.value.toLowerCase()) !== -1
    })

    dispatch(updateModalProps('roles', updatedList))
  }

  // return (
  //   <Modal show={visible} onHide={hide} id='role-modal' dialogClassName='assignment-modal' backdrop>
  //     <Modal.Header closeButton closeLabel='Cancel'>
  //       <Modal.Title>Select Role</Modal.Title>
  //     </Modal.Header>
  //     <Modal.Body>

  //           <FormGroup>
  //                 <InputGroup id='department-search-input'>
  //                  <InputGroup>
  //                   <FormControl placeholder="Search" />
  //                   <InputGroup.Text>
  //                    <span className="material-icons">search</span>
  //                   </InputGroup.Text>
  //                  </InputGroup>
  //                   <FormControl id='department-search' type='text' placeholder='Search' onChange={filterList} />
  //                 </InputGroup>
  //           </FormGroup>

  //       <ListGroup className='text-medium'>
  //         {roles.map(role =>
  //           <ListGroupItem key={role._id} onClick={() => saveSelection(role._id)}>
  //             <div className='department-name'>{role.name[languageCode]}</div>
  //           </ListGroupItem>
  //         )}
  //       </ListGroup>

  //     </Modal.Body>
  //   </Modal>
  // )




  return (
  visible && (
    <>
      <div
        className="modal fade show d-block"
        id="role-modal"
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
      >
        <div className="modal-dialog assignment-modal" role="document">
          <div className="modal-content">

            <div className="modal-header">
              <h5 className="modal-title">Select Role</h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Cancel"
                onClick={hide}
              ></button>
            </div>

            <div className="modal-body">

              <div className="mb-3">
                <div id="department-search-input" className="input-group mb-2">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                  />
                  <span className="input-group-text">
                    <span className="material-icons">search</span>
                  </span>
                </div>
                <input
                  id="department-search"
                  type="text"
                  className="form-control"
                  placeholder="Search"
                  onChange={filterList}
                />
              </div>

              <ul className="list-group text-medium">
                {roles.map((role) => (
                  <li
                    key={role._id}
                    className="list-group-item"
                    onClick={() => saveSelection(role._id)}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="department-name">
                      {role.name[languageCode]}
                    </div>
                  </li>
                ))}
              </ul>

            </div>
          </div>
        </div>
      </div>

      <div className="modal-backdrop fade show"></div>
    </>
  )
);

}

export default connect()(SelectRoleModal)
